var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import query from 'syf-component-library/const/mediaQueries';
import Inset from 'syf-component-library/ui/spacing/Inset';
import { colors, spacing } from '../../../theme';
import { StyledText } from '../../subcomponents';
export var StyledMessage = styled(StyledText)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  white-space: pre-line;\n"], ["\n  white-space: pre-line;\n"])));
export var StyledNote = styled(Inset)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  background: ", ";\n"], ["\n  background: ", ";\n"])), colors.paleGrey);
export var StyledStart = styled(Inset)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  padding: ", "px\n    ", "px;\n\n  @media ", " {\n    padding: ", "px\n      ", "px;\n  }\n"], ["\n  padding: ", "px\n    ", "px;\n\n  @media ", " {\n    padding: ", "px\n      ", "px;\n  }\n"])), spacing.xlarge, function (_a) {
    var _b = _a.verticalPadding, verticalPadding = _b === void 0 ? 48 : _b;
    return verticalPadding;
}, query.lessThanMedium, function (_a) {
    var _b = _a.mobileVerticalPadding, mobileVerticalPadding = _b === void 0 ? spacing.xlarge : _b;
    return mobileVerticalPadding;
}, spacing.base);
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=subcomponents.js.map